// Func = limiting Scope for this file
var lastScrollTop = 0;

var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');


(function(){

	let hidden_label = document.querySelector( ".field_3757QuirkCollegeClub_9 .form-module__field--label" )
	if( hidden_label ){
		hidden_label.classList.add( "hidden" );
	}

	//email signup anchor
	let url = document.URL;
	if( url.indexOf( "#email-signup" ) != "-1" ){

		const element = document.querySelector("#email-signup");
		var viewportOffset = element.getBoundingClientRect();

		if( element ){
			console.log( element );
			setTimeout( () => {
				let pos1 = viewportOffset.top;
				window.scroll({
					top: pos1,
					behavior: 'smooth'
				});
			}, 2000 )
		}
	}

	//booking Cta
	if(document.getElementById('bookingCta')){
		document.getElementById('bookingCta').addEventListener('click',function(e){
			e.preventDefault();
			if(this.classList.contains('open')){
				this.classList.remove('open');
				document.getElementById('header').classList.remove('booking-open');
				document.getElementById('bookingBlock').classList.remove('open');
				this.getElementsByTagName('span')[0].innerHTML = 'Book Now';
			} else {
				this.classList.add('open');
				document.getElementById('header').classList.add('booking-open');
				document.getElementById('bookingBlock').classList.add('open');
				this.getElementsByTagName('span')[0].innerHTML = 'Close';
			}
		})
	}

	// tablet / mobile menu cta
	if(document.getElementById('menuCta')){
		document.getElementById('menuCta').addEventListener('click', function(e){
			e.preventDefault();
			if(document.getElementById('menuContainer').classList.contains('open')){
				document.getElementById('menuContainer').classList.remove('open')
				this.classList.remove('open')
				this.getElementsByClassName('text')[0].innerHTML = 'Menu';
				if(lastScrollTop < 80){
					document.getElementById('header').classList.remove('down');
				}
			} else {
				document.getElementById('menuContainer').classList.add('open');
				this.classList.add('open');
				this.getElementsByClassName('text')[0].innerHTML = 'Close';
		
				document.getElementById('header').classList.add('down');
				
			}
		});
	}

	if(document.getElementById('primary-nav')){
		let allLinks = document.getElementById('primary-nav').getElementsByTagName('a');
		let allLinksLength = allLinks.length;
		for(let i=0; i < allLinksLength; i++){
			allLinks[i].addEventListener('click', function(e){
				if(this.nextElementSibling.classList.contains('submenu')){
					let submenuAll = document.getElementsByClassName('submenu');
					for(let h = 0; h < submenuAll.length; h++ ){
						submenuAll[h].classList.remove('open')
					}
					e.preventDefault();
					if(this.nextElementSibling.classList.contains('open')){
						this.nextElementSibling.classList.remove('open')
					} else {
						this.nextElementSibling.classList.add('open')
					}
				}
			})
		}
		for (let i = 0; i < allLinksLength; i++) {
			let parentLi = allLinks[i].parentElement; // Gets the <li> container of the link
			let submenu = parentLi.querySelector('.submenu'); //  Busca el <ul> con la clase 'submenu'
	
			if (submenu) { // If there is a submenu
				// Event for hover (mouse enters)
					allLinks[i].addEventListener('mouseover', function () {
						let allOpenSubmenus = document.querySelectorAll('#primary-nav .submenu.open');
						allOpenSubmenus.forEach((openSubmenu) => {
						openSubmenu.classList.remove('open'); 
					});
					submenu.classList.add('open'); //  Add the class 'open' to the <ul>.
				});
	
				submenu.addEventListener('mouseleave', function () {
					setTimeout(() => {
						submenu.classList.remove('open'); // Remove the 'open' class after 1 seconds
					}, 500); // 1000 ms = 1 seconds
				});
			}
			
		}
	}

	if(document.getElementsByClassName('js-accordion-title').length > 0){
		let allAccordionItems = document.getElementsByClassName('js-accordion-title');
        let allALength = allAccordionItems.length;

        for(let i =0; i < allALength; i++){
            allAccordionItems[i].addEventListener('click', function(){
                let currentParent = this.parentElement;
        
                let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
                let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0]
                if(currentParent.classList.contains('open')){
                    currentParent.classList.remove('open');
                    currentCopy.style.height = '0';
                    currentParent.setAttribute('aria-expanded','false')
                } else {
                    currentParent.classList.add('open');
                    currentCopy.style.height = currentCopyHeight + 'px';
                    currentParent.setAttribute('aria-expanded','true')
                }
            })
        }
	}

	const accordionitem = document.querySelectorAll('.accordion-item-js');

	accordionitem.forEach(items => {
		items.addEventListener('click', function(e) {
			e.preventDefault()
			// Elimina la clase "activa" de todos los encabezados
			accordionitem.forEach(items =>{
				items.classList.remove('active');
				items.nextElementSibling.classList.remove('active');
				items.parentElement.classList.remove('active');
			});

			// Agrega la clase "activa" al encabezado seleccionado
			this.classList.add('active');

			// Muestra o oculta el contenido de la sección seleccionada
			this.nextElementSibling.classList.add('active');
			this.parentElement.classList.add('active');
		});
	});
		

	

	$(document).ready(function () {

		

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		
		
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 2,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}	
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				document.getElementById("altDates").value = start + ' / ' + end;

			
			}
		});	
		//booking input change
		document.getElementById('altDates').addEventListener('change', function(){
			let currentValue = this.value.split('/');
			
			start = currentValue[0].trim();
			end = currentValue[1].trim();

			$('#bookingCalendar').datepicker("setDate", start)
			$('#bookingCalendar').datepicker("setDate", end)
		})

	});


	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		if(!document.getElementById('home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		if( document.querySelector('body.richmond') ){
			console.log('richmond');

			document.querySelector('.item.logos').classList.add('guest_book');
			document.querySelector('.guest_book_logo').classList.remove('hidden');

		}

		let anchors = document.querySelectorAll('main a');

		anchors.forEach( (anchor) => {
			if (!anchor.classList.length){
				anchor.classList.add("underline_CTA");
			}
		} )

	};

	var gdprConsentRow = document.querySelector('.pets-script');
    var bookingEventTbody = document.querySelector('.special-entry');

    if (gdprConsentRow && bookingEventTbody) {
        bookingEventTbody.appendChild(gdprConsentRow);
    } else {
        console.log('No elements were found with the specified classes.');
    }

	let form = document.getElementById("booking-form"); 
	form.addEventListener("submit", function(event) { 
		if ('function' == typeof window.fliptoDecorate) {
			 fliptoDecorate(form); 
		} 
	});

}());

function scrollW(){

	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		
		// downscroll code
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
		
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}